module.exports = __webpack_public_path__ + "img/OurPractice1.563dc3d4.png";